import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { TranslationPipeModule } from '@shared/pipes/translation-pipe.module';
import { IconButtonModule } from '../icon-button/icon-button.module';
import {
  ArkikDialogContainerComponent,
  ArkikDialogTitle,
  ArkikDialogContent,
  ArkikDialogActions,
} from './arkik-dialog.component';

@NgModule({
  declarations: [ArkikDialogContainerComponent, ArkikDialogTitle, ArkikDialogContent, ArkikDialogActions],
  imports: [CommonModule, OverlayModule, PortalModule, TranslationPipeModule, IconButtonModule],
  exports: [ArkikDialogContainerComponent, ArkikDialogTitle, ArkikDialogContent, ArkikDialogActions],
})
export class ArkikDialogModule {}
